import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AppLayout from "@/layouts/AppLayout";
import store from "@/store";

const AboutView = () =>
  import(/* webpackChunkName: "about" */ "../views/AboutView.vue");
const ContactView = () =>
  import(/* webpackChunkName: "contact" */ "../views/ContactView.vue");
const ListingView = () =>
  import(/* webpackChunkName: "top-listing" */ "../views/TopListingView.vue");
const DynamicRouteHandler = () =>
  import(/* webpackChunkName: "dynamic-route" */ "@/views/DynamicRouteHandler");
const UnitConverter = () =>
  import(/* webpackChunkName: "unit-converter" */ "@/views/UnitConverter");
const EMICalculator = () =>
  import(/* webpackChunkName: "emi-calculator" */ "@/views/EMICalculator");
const PropertyRequest = () =>
  import(/* webpackChunkName: "property-request" */ "@/views/PropertyRequest");
const BlogView = () =>
  import(/* webpackChunkName: "blog-list" */ "@/views/BlogView");
const BlogPostView = () =>
  import(/* webpackChunkName: "blog-post" */ "@/views/BlogPostView");
const BlogCategoryView = () =>
  import(/* webpackChunkName: "blog-category" */ "@/views/BlogCategoryView");
const BlogHashTagView = () =>
  import(/* webpackChunkName: "blog-hashtag" */ "@/views/BlogHashtagView");
const PropertyCompare = () =>
  import(/* webpackChunkName: "property-compare" */ "@/views/PropertyCompare");
const BlogLayout = () =>
  import(/* webpackChunkName: "blog-layout" */ "@/layouts/BlogLayout");
const RevampSingleProperty = () =>
  import(
    /* webpackChunkName: "single-property" */ "@/views/RevampSingleProperty"
  );
const OurBranchesView = () =>
  import(/* webpackChunkName: "our-branches" */ "@/views/OurBranchesView");
const OurTeamView = () =>
  import(/* webpackChunkName: "our-team" */ "@/views/OurTeamView");
const OurServicesView = () =>
  import(/* webpackChunkName: "our-services" */ "@/views/OurServicesView");
const SoldPropertyView = () =>
  import(/* webpackChunkName: "sold-property" */ "@/views/SoldPropertyView");
const VideosView = () =>
  import(/* webpackChunkName: "videos" */ "@/views/VideosView");
const TeamMemberPropertiesView = () =>
  import(
    /* webpackChunkName: "team-member-properties" */ "@/views/TeamMemberPropertiesView"
  );
const AllListingsView = () =>
  import(/* webpackChunkName: "all-listings" */ "../views/AllListingsView.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: AppLayout,
    children: [
      {
        path: "",
        name: "home",
        component: HomeView,
        beforeEnter: async (to, from, next) => {
          await store.commit("setLoading", true);
          await store.dispatch("fetchBanner").then((response) => {
            if (response) {
              response.forEach(function (banner) {
                const img = new Image();
                img.src = banner;
              });
            }
          });
          store.dispatch("fetchAchievements");
          store.dispatch("fetchTestimonials");
          store.dispatch("fetchHomeAbout");
          store.dispatch("fetchAboutData");
          store.dispatch("fetchFAQs");
          store.dispatch("fetchFrontEndFeatured");
          store.dispatch("fetchFrontEndPremium");
          store.dispatch("fetchFrontEndNewListing");
          store.dispatch("fetchUnderConstructionProperties");
          store.dispatch("fetchHomeBlogs");
          store.dispatch("fetchTopListing");

          await store.dispatch("fetchContactDetails").then((response) => {
            if (response) {
              const img = new Image();
              img.src = response;
            }
          });

          store.commit("setLoading", false);

          await next();
          Vue.prototype.$Progress.finish();
        },
      },
      {
        path: "/about-us",
        name: "about-us",
        component: AboutView,
        beforeEnter: async (to, from, next) => {
          await store.commit("setLoading", true);
          store.dispatch("fetchAboutData");
          store.dispatch("fetchFAQs");
          store.dispatch("fetchTeam");
          store.dispatch("fetchMessageFromCEO");

          await store.dispatch("fetchContactDetails").then((response) => {
            if (response) {
              const img = new Image();
              img.src = response;
            }
          });
          await store.commit("setLoading", false);
          Vue.prototype.$Progress.finish();
          await next();
        },
      },

      {
        path: "/contact-us",
        name: "contact-us",
        component: ContactView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/top-listing",
        name: "top-listing",
        component: ListingView,
        beforeEnter: async (to, from, next) => {
          await store.commit("setLoading", true);
          await store.dispatch("fetchTopListing");
          await store.commit("setLoading", false);
          Vue.prototype.$Progress.finish();
          await next();
        },
      },
      {
        path: "/property/:slug",
        name: "singleProperty",
        component: RevampSingleProperty,
        beforeEnter: async (to, from, next) => {
          if (to.params.slug) {
            await store
              .dispatch("fetchProperty", to.params.slug)
              .then(async (response) => {
                if (
                  response.message &&
                  response.message === "Property Not Found"
                ) {
                  // Don't redirect, just let the component handle the error state
                  // or you could redirect to the catch-all route to show 404
                  next(false); // Cancel navigation
                  return;
                }
                store.dispatch("fetchSimilarProperty", to.params.slug);
              });
            Vue.prototype.$Progress.finish();
            await next();
          }
        },
      },
      {
        path: "/unit-converter",
        name: "unitConverter",
        component: UnitConverter,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/emi",
        name: "emiCalculator",
        component: EMICalculator,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/property-request",
        name: "propertyRequest",
        component: PropertyRequest,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },

      {
        path: "/compare",
        name: "compareProperty",
        component: PropertyCompare,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/our-branches",
        name: "our-branches",
        component: OurBranchesView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/our-team",
        name: "our-team",
        component: OurTeamView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/team/:teamId/properties",
        name: "team-member-properties",
        component: TeamMemberPropertiesView,
        beforeEnter: async (to, from, next) => {
          console.log(
            "Entering team member properties route with ID:",
            to.params.teamId,
          );
          // Ensure team data is loaded
          await store.dispatch("fetchTeam");
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/our-services",
        name: "our-services",
        component: OurServicesView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/sold-property",
        name: "sold-property",
        component: SoldPropertyView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/videos",
        name: "videos",
        component: VideosView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "listings",
        name: "allListings",
        component: AllListingsView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
    ],
  },
  {
    path: "/",
    component: BlogLayout,
    beforeEnter: async (to, from, next) => {
      await store.dispatch("fetchHashtags");
      await store.dispatch("fetchCategories");
      await store.dispatch("fetchRecentBlogs");
      next();
    },
    children: [
      {
        path: "blogs",
        name: "blogs",
        component: BlogView,
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchAllBlogs", 1);
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "/blog/:slug",
        name: "blogPost",
        component: BlogPostView,
        beforeEnter: async (to, from, next) => {
          if (to.params.slug) {
            await store
              .dispatch("fetchBlog", to.params.slug)
              .then((response) => {
                if (response.message === "Blog Not Found") {
                  next(from);
                }
              });
            await next();
          } else {
            next(from);
          }
          Vue.prototype.$Progress.finish();
        },
      },
      {
        path: "blogs-category/:slug",
        name: "blogCategory",
        component: BlogCategoryView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
      {
        path: "blogs-hashtag/:hashtag",
        name: "blogHashTag",
        component: BlogHashTagView,
        beforeEnter: async (to, from, next) => {
          Vue.prototype.$Progress.finish();
          next();
        },
      },
    ],
  },
  // Removed the separate error route - now handled inline
  // {
  //   path: "/",
  //   component: BlankLayout,
  //   children: [
  //     {
  //       path: "error",
  //       component: Error,
  //       name: "error",
  //       beforeEnter: async (to, from, next) => {
  //         Vue.prototype.$Progress.finish();
  //         next();
  //       },
  //     },
  //   ],
  // },
  {
    path: "/:pathMatch(.*)*",
    name: "catchAll",
    component: AppLayout,
    children: [
      {
        path: "",
        name: "dynamic_or_error",
        component: DynamicRouteHandler,
        beforeEnter: async (to, from, next) => {
          // Check if this is a team member URL
          if (to.path.startsWith("/team/")) {
            return next(false);
          }

          Vue.prototype.$Progress.finish();
          next();
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
